import { Card } from "antd";
import React, { useState } from "react";
import InvitationForm from "./InvitationForm";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { userInvitation } from "../../../API/api";

const errorToast = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export default function Invitation({isInvite}) {
  const state = useSelector(state=>state.manageUsers);
  const [users, setUsers] = useState([
    {
      firstName: "",
      lastName: "",
      email: "",
      roles: [],
      userType: null,
    },
  ]);
  const onRemoveButton = (ind)=>{
    setUsers(users.filter((_, i) => i!==ind));
  }
  const onchangeName = (ind,text,key)=>{
    if(key==='first'){
      let newData = users.filter((user,index)=>{
        if(index===ind){
          user.firstName=text;
        }
        return user;
      })
      setUsers(newData);
    }
    if(key==='last'){
      let newData = users.filter((user,index)=>{
        if(index===ind){
          user.lastName=text;
        }
        return user;
      })
      setUsers(newData);
    }
    if(key==='email'){
      let newData = users.filter((user,index)=>{
        if(index===ind){
          user.email=text;
        }
        return user;
      })
      setUsers(newData);
    }
    if(key==='role'){
      let newData = users.filter((user,index)=>{
        if(index===ind){
          user.roles=text;
        }
        return user;
      })
      setUsers(newData);
    }
    if(key==='usertype'){
      let newData = users.filter((user,index)=>{
        if(index===ind){
          user.userType=text;
        }
        return user;
      })
      setUsers(newData);
    }
  }
  const onSubmit = ()=>{
    let isError =false;
    users.forEach(user=>{
      if(!user.firstName ||!user.lastName ||!user.email ||user.roles.length ===0 ||!user.userType){
        isError=true;
      }
    })
    if(isError){
      toast.warning(errorToast("Please fill all the fields!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    let asdf = users.filter(obj=>{
      obj.roles = state.roleList.filter(roles=> obj.roles.includes(roles.roleId));
      return obj
    })
    userInvitation(asdf).then(res=>{
      if(res===undefined) return;
      if(res.data.success){
        setUsers([]);
        isInvite();
        toast.success(()=>{
          return(<>
          <span style={{fontSize:'12px'}}>{res.data.message}</span>
          </>)
        })
      }
    })
  }
  return (
    <>
      <Card style={{ boxShadow: "7px 7px 20px lightgrey" }}>
        <h1
          style={{ textAlign: "center", fontWeight: "300", fontSize: "22px" }}
        >
          <i className="fa fa-paper-plane-o" style={{ fontSize: "30px" }}></i>{" "}
          Invite people to Vizerto
        </h1>
        {/* <Divider style={{ marginBlock: "5px" }} /> */}
        
        <div>
            {users.map((user, index)=>{
                return(
                    <InvitationForm key={user} index={index} data={user} onChangeFunc={onchangeName} onRemove={onRemoveButton} />
                )
            })}
            <div className="mt-2" style={{display:'flex', justifyContent:'space-between'}}>
            <div><span onClick={()=>setUsers([...users, {fName: "",lName: "",email: "",role: [],userType: null}])} style={{fontSize:'14px', color:'var(--light_color_shade)',cursor:'pointer'}}><i className="fa fa-plus"></i>&nbsp;Add Another</span></div>
            <div><button onClick={()=>isInvite()} style={{fontSize:'14px', color:'black', background:'#fff',border:'1px solid black',borderRadius:'4px',cursor:'pointer'}}>Cancel</button>&nbsp;&nbsp;<button style={{fontSize:'14px', color:'#fff', background:'var(--light_color_shade)',border:'1px solid var(--light_color_shade)',borderRadius:'4px',cursor:'pointer'}} onClick={()=>onSubmit()}>Send Invitations</button></div>
        </div>
        </div>
      </Card>
    </>
  );
}
